import "@mantine/core/styles.css"
import "@mantine/dates/styles.css"
import "@mantine/notifications/styles.css"
import "@mantine/tiptap/styles.css"
import "mantine-react-table/styles.css"
import "@mantine/dropzone/styles.css"
import "@mantine/carousel/styles.css"

import ReactDOM from "react-dom/client"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import Duration from "dayjs/plugin/duration"
import RelativeTime from "dayjs/plugin/relativeTime"
import UTC from "dayjs/plugin/utc"
import WeekOfYear from "dayjs/plugin/weekOfYear"
import IsToday from "dayjs/plugin/isToday"
import DayOfYear from "dayjs/plugin/DayOfYear"
import dayjs from "dayjs"
import LOCALE_DE from "dayjs/locale/de"
import LOCALE_ENGB from "dayjs/locale/en-gb"
import "./i18n.ts"
import isoWeek from "dayjs/plugin/isoWeek"
import { App } from "./App.tsx"
import customParseFormat from "dayjs/plugin/customParseFormat"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import { ApplicationProviders } from "./ApplicationProviders.tsx"

dayjs.extend(WeekOfYear)
dayjs.extend(DayOfYear)
dayjs.extend(LocalizedFormat)
dayjs.extend(Duration)
dayjs.extend(RelativeTime)
dayjs.extend(UTC)
dayjs.locale(LOCALE_DE)
dayjs.locale(LOCALE_ENGB)
dayjs.extend(IsToday)
dayjs.extend(isoWeek)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

const root = document.getElementById("root")
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ApplicationProviders>
        <App />
      </ApplicationProviders>
    </React.StrictMode>
  )
}
